<template>
  <li class="destinations" data-test="mobile-menu__destinations">
    <MobileMenuItem
      :item="config.item"
      :panel="true"
      :utag-event-info="{
        event_act: 'hotels and destinations',
        event_lbl: 'dropdown',
      }"
    >
      <template #panel>
        <!-- Continents list to tabs -->
        <div v-if="!isCuba" class="continents-tab">
          <MobileMenuItem
            v-for="(continent, index) in continents"
            :id="continent.id"
            :key="continent.id"
            :item="{ name: continent.title, url: '#' }"
            :type="'child-item t-fb-label'"
            :class="{ active: index === 0 }"
            :tab="true"
            :utag-event-info="{
              event_act: 'hotels and destinations',
              event_lbl: 'continent',
              destination_continent: continent.data.title_en.toLowerCase(), // Continente
              hotel_headquarter_final: continent.data.headquarter_slug, // Gestora del continente
            }"
          >
          </MobileMenuItem>
        </div>
        <div class="continents-panels">
          <ul
            v-for="(continent, index) in continents"
            :id="'continent-panel-' + continent.id"
            :key="'continent-panel-' + continent.id"
            :class="['destinations-panel', { hidden: index !== 0 }]"
          >
            <!-- Countries -->
            <MobileMenuItem
              v-for="country in filterDestination(continent.id)"
              :key="country.id"
              :item="{
                name: country.title,
                num: getNumHotels(country.id),
                url: '#',
              }"
              :type="'child-item'"
              :panel="true"
              :utag-event-info="{
                event_act: 'hotels and destinations',
                event_lbl: 'country',
                destination_continent: continent.data.title_en.toLowerCase(), // Continente
                destination_country: country.data.title_en.toLowerCase(), // País
                hotel_headquarter_final: continent.data.headquarter_slug, // Gestora del continente
              }"
            >
              <template #panel>
                <ul class="destinations-panel">
                  <!-- Destinations -->
                  <MobileMenuItem
                    v-for="destination in filterDestination(country.id)"
                    :key="destination.id"
                    :item="{
                      name: destination.title,
                      num: getNumHotels(destination.id),
                      url: '#',
                    }"
                    :type="'child-item'"
                    :panel="true"
                    :utag-event-info="{
                      event_act: 'hotels and destinations',
                      event_lbl: 'city',
                      destination_continent: continent.data.title_en.toLowerCase(), // Continente
                      destination_country: country.data.title_en.toLowerCase(), // País
                      destination_city: destination.data.title_en.toLowerCase(), // Ciudad
                      hotel_headquarter_final: continent.data.headquarter_slug, // Gestora del continente
                    }"
                  >
                    <template #panel>
                      <ul class="destinations-panel">
                        <!-- Hotels -->
                        <MobileMenuItem
                          v-for="hotel in getHotels(destination.id)"
                          :key="hotel.id"
                          :item="{
                            name: hotel.title,
                            url: hotel.data.url,
                          }"
                          :type="'child-item-with-arrow'"
                          :utag-event-info="{
                            event_act: 'hotels and destinations',
                            event_lbl: 'hotel',
                            destination_continent: continent.data.title_en.toLowerCase(), // Continente
                            destination_country: country.data.title_en.toLowerCase(), // País
                            destination_city: destination.data.title_en.toLowerCase(), // Ciudad
                            hotel_headquarter_final: continent.data.headquarter_slug, // Gestora del continente
                            hotel_sku: hotel.data.hotel_code, // Identificador del producto
                            hotel_short_name: hotel.data.abrev, // Nombre abreviado
                            hotel_name: hotel.title.toLowerCase(), // Nombre completo
                            hotel_segment: hotel.data.segmentations.length ? hotel.data.segmentations[0].class : '', // Nombre del segmento
                            hotel_subsegment: hotel.data.subsegmentations.length
                              ? hotel.data.subsegmentations[0].class
                              : '', // Nombre del subsegmento
                            hotel_brand: hotel.data.brand, // Nombre de la marca
                            hotel_is_only_adults: hotel.data.adults_only, // ¿Es sólo adultos?
                            hotel_stars: hotel.data.hotel_category_number, // Estrellas
                            hotel_type: hotel.data.hotel_type, // Tipo de hotel
                          }"
                        />
                        <!-- End hotels -->

                        <MobileMenuItem
                          :item="{ name: config.hotels_in_text + ' ' + destination.title, url: destination.data.url }"
                          :type="'view-all child-item'"
                        />

                        <MobileMenuExperiences
                          v-if="!isCuba"
                          :a11y="{
                            all: config.all,
                            choose_experiences: config.choose_experiences,
                            all_url: config.all_url,
                          }"
                        />
                      </ul>
                    </template>
                  </MobileMenuItem>
                  <!-- End destinations -->

                  <MobileMenuItem
                    :item="{ name: config.destinations_in_text + ' ' + country.title, url: country.data.url }"
                    :type="'view-all child-item'"
                  />

                  <MobileMenuExperiences
                    v-if="!isCuba"
                    :a11y="{ all: config.all, choose_experiences: config.choose_experiences, all_url: config.all_url }"
                  />
                </ul>
              </template>
            </MobileMenuItem>
            <!-- End countries -->
          </ul>
        </div>
        <!-- End continents list to tabs -->

        <MobileMenuItem :item="config.hotels_item" :type="'view-all child-item'" />

        <MobileMenuExperiences
          :a11y="{ all: config.all, choose_experiences: config.choose_experiences, all_url: config.all_url }"
        />
      </template>
    </MobileMenuItem>
  </li>
</template>

<script>
import _filter from 'lodash/filter'
import _groupBy from 'lodash/groupBy'
import _sortBy from 'lodash/sortBy'

import MobileMenuExperiences from '../MobileMenuExperiences/MobileMenuExperiences'
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'

const componentName = 'MobileMenuDestinations'

export default {
  name: componentName,
  components: {
    MobileMenuItem,
    MobileMenuExperiences,
  },
  props: {
    config: Object,
  },
  data() {
    return {
      data: [],
      allDestinations: [],
      allHotels: [],
      continents: [],
    }
  },
  computed: {
    isCuba() {
      return document.documentElement.dataset.inMicrosite == 'ibercuba'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const vm = this
      IB.hotels_data.check()
        ? vm.processData()
        : IB.hotels_data.get(() => {
          vm.processData()
        })
    },
    processData() {
      const vm = this
      vm.data = IB.hotels_data.getData()
      vm.allDestinations = vm.data.destinations[1]
      vm.allHotels = _groupBy(vm.data.hotels[1], 'data.destination')

      vm.continents = _sortBy(
        _filter(vm.allDestinations, o => {
          return o.data.depth == 0
        }),
        'position'
      )
    },
    filterDestination(id) {
      const vm = this
      return _sortBy(
        _filter(vm.allDestinations, function (o) {
          return o.data.parent_id == id && vm.getHotels(o.id).length
        }),
        'title'
      )
    },
    getHotels(id) {
      const vm = this
      let hotels = _filter(vm.allHotels[id], function (o) {
        return o.data.destination == id
      })
      // Quito condición debido a 979185 - No se visualizan varios hoteles en MEX
      // if (!hotels.length) {
      const t = this.filterDestination(id)
      t.forEach(function (element) {
        hotels = hotels.concat(vm.getHotels(element.id))
      })
      //}

      return _sortBy(hotels, 'title')
    },
    getNumDestinations(id) {
      const vm = this
      return ` (${vm.filterDestination(id).length})`
    },
    getNumHotels(id) {
      const vm = this
      return ` (${vm.getHotels(id).length})`
    },
  },
}
</script>
